import { render, staticRenderFns } from "./select-dialog.vue?vue&type=template&id=1859f4fc&"
import script from "./select-dialog.vue?vue&type=script&lang=js&"
export * from "./select-dialog.vue?vue&type=script&lang=js&"
import style0 from "./select-dialog.vue?vue&type=style&index=0&id=1859f4fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports